module.exports = "/fonts/Roboto-Light.ttf?2382fa8a8afcdbe3124c840bd6ef7024";